export default "__VITE_ASSET__BZse56GL__"